export default __webpack_public_path__ + "static/media/background.d6118e1e.jpg";